const makeInitialValues = agent => ({
  agentId: agent?.id || ''
});

export default makeInitialValues;
